function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React from 'react';
import Gallery from './galleryContainerExtraNew.js';
import ProGallery from './proGallery';

var ProBlueprintsGallery = /*#__PURE__*/function (_ProGallery) {
  _inheritsLoose(ProBlueprintsGallery, _ProGallery);

  function ProBlueprintsGallery() {
    return _ProGallery.apply(this, arguments) || this;
  }

  var _proto = ProBlueprintsGallery.prototype;

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement("div", this.containerProps(), /*#__PURE__*/React.createElement(Gallery, this.renderProps()));
  };

  return ProBlueprintsGallery;
}(ProGallery);

export { ProBlueprintsGallery as default };